export default __webpack_public_path__ + "static/media/Brow_6_C3.4e264773.svg";